import { render, staticRenderFns } from "./AddAccountSchool.vue?vue&type=template&id=40f0fb28&scoped=true"
import script from "./AddAccountSchool.vue?vue&type=script&lang=js"
export * from "./AddAccountSchool.vue?vue&type=script&lang=js"
import style0 from "./AddAccountSchool.vue?vue&type=style&index=0&id=40f0fb28&lang=css"
import style1 from "./AddAccountSchool.vue?vue&type=style&index=1&id=40f0fb28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0fb28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f0fb28')) {
      api.createRecord('40f0fb28', component.options)
    } else {
      api.reload('40f0fb28', component.options)
    }
    module.hot.accept("./AddAccountSchool.vue?vue&type=template&id=40f0fb28&scoped=true", function () {
      api.rerender('40f0fb28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/AddAccountSchool.vue"
export default component.exports